import React from 'react'

import { Heading } from '@/components/ui/heading'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  step: string
}

const Step: React.FC<Props> = ({
  step = '1',
  className,
  children,
  ...props
}) => {
  return (
    <div className={cn('my-6', className)} {...props}>
      <Heading size={4} className="text-primary mt-0 mb-1">
        Step {step}
      </Heading>
      {children}
    </div>
  )
}

export default Step
